import http from "@utils/request";

/**
 * 获取管线数据
 */
export const getPipelinelayer = () => http({
  method: "POST",
  url: "/pipeline/pipelinelayer"
});
/**
 * 获取站点图层
 */
export const getStationLayer=()=>http({
  url:"/pipeline/stationlayer"
});
/**
 * 获取厂区图层
 */
export const getFactoryLayer=()=>http({
  url:"/pipeline/factorylayer"
});

/**
 * 根据图层名称和工作空间获取图层数据
 */
 export const getLayerByName=(workspace,layername)=>http({
  url:"/pipeline/getLayerByName",
  method:"POST",
  data:{
    workspace,layername
  }
});


/**
 * 获取配置信息
 */
export const getUserSetting=(configname)=>http({
  method:"POST",
  url:"/user/getUserSetting",
  data:{
    configname // 配置项的名称
  }
});

/**
 * 获取站点的实时数据
 */
export const getStationTimingData=()=>http({
  method:"POST",
  url:"/pipeline/getStationTimingData",
  // 不显示加载框
  unloading:false
});

/**
 * 获取管线的实时数据
 */
export const getPipelineTimingData=(currentColorSetting)=>http({
  method:"POST",
  url:"/pipeline/getPipelineTimingData",
  data:{
    currentColorSetting
  },
  // 不显示加载框
  unloading:false
});

/**
 * 获取管线的实时数据
 */
export const getSimulationValue=(currentColorSetting,similationValue)=>http({
  method:"POST",
  url:"/pipeline/getSimulationValue",
  data:{
    currentColorSetting,similationValue
  }
});

/**
 * 获取管线上某一点的数值
 * @param {*} lineId 
 * @param {*} subIndex 
 * @param {*} pattern 
 * @param {*} similationValue 
 */
export const pipelineRealDataByID=(lineId,subIndex,pattern,similationValue)=>http({
  method:"POST",
  url:"/pipeline/pipelineRealDataByID",
  data:{
    lineId,subIndex,pattern,similationValue
  },
  // 不显示加载框
  unloading:false
});

/**
 * 获取管道的保温材料
 * @param {*} linenumber 
 */
export const pipelinePropertyByNumber=(linenumber)=>http({
  url: "http://phemsgis.dev.proheng.net/hdxsserverdev/api/getPipelinePropertyByNumber"
  ,data:{
    linenumber
  },
  // 不显示加载框
  unloading:false
});
/**
 * 获取管道数据的区间值
 * @param {*} itemname 
 * @param {*} maxdata2 
 * @param {*} simulationValue 
 */
export const getPipelineDataSection=(itemname,maxdata2,simulationValue)=>http({
  url:"/pipeline/GetPipelineDataSection",
  data:{
    itemname,maxdata2,simulationValue
  }
});
/**
 * 保存用户配置
 * @param {*} itemname 
 * @param {*} config 
 */
export const setUserSetting=(itemname,config)=>http({
  url:"/user/setUserSetting",
  method:"POST",
  data:{
    itemname,config
  }
})
/**
 * 获取管道故障数据
 * @returns 
 */
export const pipelineFaultData=()=>http({
  url:"/pipeline/pipelineFaultData",
  method:"POST"
});